import { CachedTransform, CombineDynamicPropMaps } from "js-vextensions";
import { GetCharacter } from "Store/firebase/characters";
import { StoreAccessor, GetDocs, WhereOp, GetDoc } from "mobx-firelink";
export const GetEvents = StoreAccessor("GetEvents", s => (bookID) => {
    return GetDocs({
        queryOps: [new WhereOp("book", "==", bookID)],
    }, "events");
});
export const GetEvent = StoreAccessor("GetEvent", s => (id) => {
    if (id == null)
        return null;
    return GetDoc({}, a => a.events.get(id));
});
export const GetSelectedEvent = StoreAccessor("GetSelectedEvent", s => () => {
    const selectedID = s.main.write.selectedEvent;
    return GetEvent(selectedID);
});
export const GetSelectedEvent_Character = StoreAccessor("GetSelectedEvent_Character", s => () => {
    const id = s.main.write.selectedEvent_character;
    return GetCharacter(id);
});
export const GetEventIndexes = StoreAccessor("GetEventIndexes", s => (characterID) => {
    if (characterID == null)
        return {};
    return GetDoc({}, a => a.characters.get(characterID))?.eventIndexes || {};
});
export const GetEventIndex = StoreAccessor("GetEventIndex", s => (characterID, eventID) => {
    if (characterID == null || eventID == null)
        return null;
    /*const eventIndexEntry = GetEventIndexes(characterID).Pairs().find(a=>a.value == eventID);
    if (eventIndexEntry == null) return null;
    return eventIndexEntry.keyNum;*/
    return GetEventIndex_FromIndexes(GetEventIndexes(characterID), eventID);
});
export const GetEventIndex_FromIndexes = StoreAccessor("GetEventIndex_FromIndexes", s => (eventIndexes, eventID) => {
    const eventIndexEntry = eventIndexes.Pairs().find(a => a.value == eventID);
    if (eventIndexEntry == null)
        return null;
    return eventIndexEntry.keyNum;
});
export const GetEventIDs_Ordered = StoreAccessor("GetEventIDs_Ordered", s => (characterID) => {
    return GetEventIndexes(characterID).VValues();
});
export const GetCharacterEvents = StoreAccessor("GetCharacterEvents", s => (bookID, characterID) => {
    return GetEvents(bookID).filter(a => a.characters[characterID]);
});
export const GetUnorderedEvents = StoreAccessor("GetUnorderedEvents", s => (bookID, characterID) => {
    return GetEvents(bookID).filter(a => a.characters[characterID] && GetEventIndex(characterID, a._key) == null);
});
export const GetOrderedEvents = StoreAccessor("GetOrderedEvents", s => (bookID, characterID, orderResult = false) => {
    const bookEvents = GetEvents(bookID);
    const eventIndexes = GetEventIndexes(characterID);
    return CachedTransform("GetOrderedEvents", [bookID, characterID, orderResult], CombineDynamicPropMaps(bookEvents, eventIndexes), () => {
        let result = GetEvents(bookID).filter(a => a.characters[characterID] && GetEventIndex_FromIndexes(eventIndexes, a._key) != null);
        if (orderResult) {
            result = result.OrderBy(a => GetEventIndex_FromIndexes(eventIndexes, a._key));
        }
        return result;
    });
});
export const GetEventWeekAndDay = StoreAccessor("GetEventWeekAndDay", s => (event, bookID, characterID, ignoreOwnProps = false) => {
    const orderedEvents = GetOrderedEvents(bookID, characterID, true);
    let week;
    let day;
    const eventIndex = orderedEvents.findIndex(a => a._key == event._key);
    if (eventIndex != -1) {
        for (const earlierEvent of orderedEvents.slice(0, ignoreOwnProps ? eventIndex : eventIndex + 1).Reversed()) {
            // apply day first, so that week's "day 1 fallback" doesn't overwrite the specified day
            if (earlierEvent.day != null) {
                day = day != null ? day : earlierEvent.day;
            }
            if (earlierEvent.week != null) {
                week = week != null ? week : earlierEvent.week;
                day = day != null ? day : 1;
            }
            if (week != null && day != null)
                break;
        }
    }
    return { week, day };
});
